function OfferMeedyVO(id, name, orderName, additionalDescription, code, codeIcd9, type, fasting, active, offerGroup) {

    this.id = id;
    this.name = name;
    this.orderName = orderName;
    this.additionalDescription = additionalDescription;
    this.code = code;
    this.codeIcd9 = codeIcd9;
    this.type = type;
    this.fasting = fasting;
    this.active = active;
    this.offerGroup = offerGroup;

    var _typeContext = {
        offerGroup : OfferGroupMeedyVO
    };

    this._getType = function (property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}
